export default Object.freeze({
  Multiplication: 'multiplication',
  Division: 'division',
  Sum: 'sum',
  Subtraction: 'subtraction',
  Average: 'average',
  Count: 'count',
  Max: 'max',
  Min: 'min',
  Concatenate: 'concatenate',
});
